import PermissionsTable from "./PermissionsTable";

export default PermissionsTable;
